import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyCreateAudit = lazyWithRetry(() => import("./CreateAudit"));

const CreateAudit = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyCreateAudit {...props} />;

export default CreateAudit;
